module.exports = __webpack_public_path__ + "img/ni.13f3517a.svg";